module.exports = function (app) {
    'use strict';

    app.controller('pages.assistEmployees.visionProvider', ['$scope', 'services', '$sce',
        function ($scope, services, $sce) {

            $scope.sidebar = {
                breadCrumb : {
                    primary : {
                        title: "Assist Employees",
                        state: "assistEmployees"
                    },
                    secondary : {
                        title: "Vision Provider"
                    }
                }
            };

            $scope.viewstate = 'loading';

            services.eprsvc.visionProvider().fetch().then(
                function(response){
                    if(response && response.data && response.data.payload && response.data.payload.url && response.data.payload.operation.toUpperCase() === 'IFRAME'){
                        $scope.iFrameSrc = $sce.trustAsResourceUrl(response.data.payload.url);
                        $scope.viewstate = 'success';
                   }
                },
                function(error){
                    $scope.viewstate = 'error';
                }
            );
        }
    ]);
};